import React from 'react'
import styles from './UIGameEndRankedScreen.module.scss'
import {useUIGameEndContext} from '../../../contexts/UIGameEndContext.tsx'
import {MMRChange} from './MMRChange/index.ts'
import {type RankedMMRState, type RankedPlacementState, RankedUserStateType} from '@colonist/leaderboard-types'
import {PlacementChange} from './PlacementChange/index.ts'
import {FADE_IN_ANIMATION_DELAYS} from '../constants.ts'
import {FadeInContainer} from '../../../common/FadeInContainer/index.ts'

export function UIGameEndRankedScreen({onContinue, disableAnimation}: {onContinue: VoidFunction, disableAnimation: boolean}) {
    const {currentPlayerRankedState} = useUIGameEndContext()
    const getRankChangeScreen = () => {
        const rankedType = currentPlayerRankedState?.type
        if(rankedType === RankedUserStateType.Ranked) {
            return <MMRChange onContinue={onContinue} rankedState={currentPlayerRankedState as RankedMMRState} disableAnimation={disableAnimation} />
        }
        if(rankedType === RankedUserStateType.RankedLocked || rankedType === RankedUserStateType.Placement) {
            return <PlacementChange onContinue={onContinue} rankedState={currentPlayerRankedState as RankedPlacementState} />
        }
        return null
    }

    return <FadeInContainer
        animationDelayMs={FADE_IN_ANIMATION_DELAYS.content}
        animationDurationMs={FADE_IN_ANIMATION_DELAYS.transitionDuration}
        disableAnimation={disableAnimation}
        className={styles.container}
    >
        {getRankChangeScreen()}
    </FadeInContainer>
}
